/* Moose sticky mobile add-to-cart.
   Shows the bar when the main product form's submit button leaves the
   viewport, mirrors the currently selected variant title and price from
   the main product info block, and forwards clicks to the real button. */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-moose-sticky-atc]');
    if (!bar) return;

    var mainSubmit = document.querySelector('product-form .product-form__submit, form[action*="/cart/add"] [name="add"]');
    var productInfo = document.querySelector('product-info') || document.querySelector('section .product');
    if (!mainSubmit) return;

    var variantLabel = bar.querySelector('[data-sticky-variant]');
    var priceLabel = bar.querySelector('[data-sticky-price]');
    var addBtn = bar.querySelector('[data-sticky-add]');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.removeAttribute('data-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else if (entry.boundingClientRect.top < 0) {
            // Only show after the button has scrolled ABOVE the viewport,
            // not before the user has reached it.
            bar.setAttribute('data-visible', '');
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainSubmit);

    function syncFromMain() {
      if (!productInfo) return;
      var priceEl = productInfo.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
      if (priceEl && priceLabel) priceLabel.textContent = priceEl.textContent.trim();

      var selected = [];
      productInfo.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select').forEach(function (el) {
        var value = el.tagName === 'SELECT' ? el.options[el.selectedIndex].textContent : el.value;
        if (value) selected.push(value.trim());
      });
      if (selected.length && variantLabel) variantLabel.textContent = selected.join(' / ');
    }

    if (productInfo) {
      productInfo.addEventListener('change', function () {
        // Wait for Dawn to re-render the price after a variant change.
        setTimeout(syncFromMain, 500);
      });
    }
    syncFromMain();

    addBtn.addEventListener('click', function () {
      mainSubmit.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
